import { clearSiteSession, currentSite, HOME_SMART_LOGIN, isHomeSmartPublicPage, isHomeSmartSite } from './brandSession';

export const isHomeSmartSession = isHomeSmartSite;
export const redirectExpiredSession = ({site = currentSite(), token} = {}) => {
  if (!clearSiteSession(site, token) || site !== currentSite() || isHomeSmartPublicPage()) return;
  window.location.assign(site === 'home-smart' ? HOME_SMART_LOGIN : '/login');
};
export const handleUnauthorizedStatus = (status, session) => {
  if (status !== 401) return false;
  // A status alone cannot identify which session the failed request belonged to.
  if (session?.site && Object.prototype.hasOwnProperty.call(session, 'token')) redirectExpiredSession(session);
  return true;
};